(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:RemoteService
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('RemoteService', RemoteService);

    function RemoteService($q, $http,ApplicationService) {
        var self = this,
            baseUrl = '/admin/aeroLineCrewAdmin',
            headers = {
                showLoading: {'show-loading': true},
                ignoreMe: {'ignore-me': true}
            };

        /**
         * All End point Configurations
         * Property name configure here will turn in to Service members and can be access via service
         * EX   RemoteService.ping();
         *      RemoteService.renewToken();
         * **/
        var endPointConfig = {
            /*******************/
            /*PING SERVICE ENDPOINTS*/
            ping: {
                url: '/pingService/ping/',
                type: 'GET',
                queryParam: ['echoToken']
            },
            undoAction: {
                url: '/undo',
                type:'GET'
            },
            /*******************/
            /*ADMIN AUTH ENDPOINTS*/

            logout: {
                url: '/adminAuthService/logout',
                type: 'GET',
                queryParam: ['tokenId']

            },
            renewToken: {
                url: '/adminAuthService/renewToken',
                type: 'GET',
                queryParam: ['tokenId'],
                headerParam: headers.ignoreMe
            },
            login: {
                url: '/adminAuthService/login',
                type: 'POST'
            },
            changePassword: {
                url: '/adminAuthService/changePassword',
                type: 'POST'
            },
            aDLogin: {
              url: '/auth/login',
              type: 'GET'
            },
            isSSOEnabled: {
              url: '/auth/sso/status',
              type: 'GET'
            },
            getSSOResult: {
              url: '/auth/sso/result',
              type: 'GET',
              queryParam: ['ref']
            },


            /*******************/
            /*COMMON ENDPOINTS*/
            getTenant : {
            	 url: '/commonService/get/tenant',
                 type: 'GET',
                 headerParam: headers.showLoading
            },
            getReportServerBaseUrl: {
                url: '/commonService/get/report/server/base/url',
                type: 'GET',
                headerParam: headers.showLoading
            },
            getTrainingProgramsByCategoryCode: {
                url: '/commonService/trainingPrograms/byCategoryCode',
                type: 'GET',
                headerParam: headers.showLoading,
                queryParam: ['trainingCategoryCode']
            },
           getAllTrainingPrograms: {
            url: '/commonService/trainingPrograms/all',
            type: 'GET',
            headerParam: headers.showLoading
          },
            getCrewTypeList: {
                url: '/commonService/crew/types',
                type: 'GET'
            },
            getCrewDesignations: {
                url: '/commonService/crew/designations',
                type: 'GET'
            },
            getPassportParamValue: {
              url: '/commonService/appParams/isValidatePassportNo/flag',
              type: 'GET'
            },
            getDefaultMinGroundTime : {
            	url: '/commonService/appParams/default/min/ground/time',
                type: 'GET'
            },
            searchStatusOfMsgs :{
            	url: '/commonService/search/condition/of/msgs',
                type: 'GET'
            },
            getMsgStatus: {
              url: '/commonService/get/msg/status',
              type: 'GET'
            },
            searchNonCrewUsers: {
              url: '/commonService/search/non/crew/users',
              type: 'GET'
            },
            getMessageCategories: {
              url: '/commonService/message/categories',
              type: 'GET'
            },
            getMessagePriorities: {
              url: '/commonService/message/priorities',
              type: 'GET'
            },

            getMessageSentBy: {
              url: '/commonService/message/sentBy',
              type: 'GET'
            },
            getTrackingTimeZone: {
                url: '/commonService/appParams/trackingTimeZone',
                type: 'GET'
            },
          getAeroOpsEnableParam: {
              url: '/commonService/appParams/aeroOpsEnableParam',
              type: 'GET'
            },
            loadWeekStartDay: {
                url: '/commonService/appParams/weekStartDay',
                type: 'GET'
            },
            getAircraftTypeList: {
                url: '/commonService/aircraft/types',
                type: 'GET'
            },
            getAircraftModels: {
                url: '/commonService/aircraft/models',
                type: 'GET'
            },
            getBaseList: {
                url: '/commonService/baseList',
                type: 'GET'
            },
            getACMITypesList: {
                url: '/commonService/getACMITypesList',
                type: 'GET'
            },
            getCrewGroups: {
                url: '/commonService/crew/groups',
                type: 'GET'
            },
            getOffContracts: {
                url: '/commonService/crew/off/contract/types',
                type: 'GET'
            },
            getCrewCategory: {
                url: '/commonService/crew/category',
                type: 'GET'
            },
            getMemoCategories: {
                url: '/commonService/memo/categories',
                type: 'GET'
            },
            loadAirportList: {
                url: '/commonService/airports',
                type: 'GET'
            },
            loadCrewCategoryList: {
                url: '/commonService/crew/category',
                type: 'GET'
            },
            loadRuleClassificationTypes: {
              url: '/commonService/rule/classification/types',
              type: 'GET'
            },
            getFlights: {
                url: '/commonService/getFlights',
                type: 'GET',
                queryParam: ['date']
            },
            getCrewTypeMasterCodes: {
                url: '/commonService/crewTypeMasterCodes',
                type: 'GET'
            },
            getDelayCodeDetails: {
                url: '/commonService/delayCodeDetails',
                type: 'GET'
            },
            loadApproachTypes: {
                url: '/commonService/approachTypes',
                type: 'GET'
            },
            loadAircraftList: {
                url: '/commonService/search/aircrafts/list',
                type: 'POST'
            },
            loadExtraFuelReasons: {
              url: '/commonService/search/extraFuelReasons/list',
              type: 'POST'
            },
            loadUserPrivileges: {
                url: '/commonService/priviledges',
                type: 'GET',
                pathParam: ['view']
            },
            getDutySheetRefreshingTime: {
              url: '/commonService/duty/sheet/refreshing/time',
              type: 'GET'
            },

            getTrainerTraineeTypes: {
                url: '/commonService/trainrer/trainee/types',
                type: 'GET',
                pathParam: ['crewProfileId', 'trainingProgId', 'selectedTrainingSlotId', 'startTimeTraining', 'crewId']
            },

            getTrainerTraineeCourses: {
            	url: '/commonService/trainrer/trainee/courses',
            	type: 'GET',
            	pathParam: ['crewProfileId', 'trainingProgId', 'crewId']
            },

            getTrainerTraineeCoursesForHub: {
            	url: '/commonService/trainrer/trainee/courses/hub',
            	type: 'GET',
            	pathParam: ['crewProfileId', 'trainingProgId', 'crewId', 'otherHub']
            },

            getBaseAirport: {
                url: '/commonService/base/airport',
                type: 'GET'
            },
            loadCrewList: {
                url: '/commonService/search/crew',
                type: 'POST',
                headerParam: headers.showLoading
            },
          loadRosterCrewList: {
            url: '/commonService/search/crew/for/roster',
            type: 'POST',
            headerParam: headers.showLoading
          },
          loadCrewListBasedOnDateRange: {
            url: '/commonService/search/crewBasedOnDateRange',
            type: 'POST'
          },
          loadInstructorList: {
            url: '/commonService/search/instructors',
            type: 'GET'
          },
          loadAirlineList: {
            url: '/commonService/search/airline',
            type: 'GET',
            pathParam: ['ownAirline']
          },
            loadCurrentTime: {
                url: '/commonService/search/local/time',
                type: 'GET',
                pathParam: ['timeZone']
            },
            loadCountryList: {
                url: '/commonService/countries',
                type: 'GET'
            }, loadTrainingCategories: {
                url: '/commonService/training/categories',
                type: 'GET'
            },
            loadAllTrainingCategories: {
                url: '/commonService/training/allcategories',
                type: 'GET'
            },
            loadCrewBatchList: {
                url: '/adminService/search/batch',
                type: 'POST'
            },
            loadCrewAttributeList: {
                url: '/adminService/search/attribute',
                type: 'POST'
            },
            getAssignedBatchesForCrew: {
                url: '/adminService/search/crew/assignedBatches',
                type: 'POST'
            },
            assignCrewToBatchFromProfile: {
                url: '/adminService/assign/crew/batch',
                type: 'POST'
            },
            removeCrewFromBatchFromProfile: {
                url: '/adminService/remove/crew/batch',
                type: 'POST'
            },
            loadNationalityList: {
                url: '/commonService/search/nationalities',
                type: 'GET'
            },
            loadRoleNameList: {
                url: '/commonService/search/role/names',
                type: 'GET'
            },
            loadTrainingLocationByStation: {
                url: '/commonService/trainingLocations/byStation',
                type: 'GET',
                queryParam: ['station']
            },
            getCrewScheduleBlockViewFlagsEnable: {
                url: '/commonService/appParams/crew/schedule/block/view/flags/enable',
                type: 'GET'
            },
            loadPrivilageList:{
                url: '/commonService/search/privilages',
                type: 'GET'
            },
            loadMenu:{
                url: '/commonService/load/menus',
                type: 'GET'
            },
            loadCrewOperTypes:{
            	url:'/commonService/get/crew/operationalTypes',
            	type:'GET'
            },
            getDelayCodes:{
            	url: '/commonService/delayCodeDetails',
            	type: 'GET',
            },
            getCabinFlightDelayCodes:{
            	url: '/commonService/cabinFlight/delayCodeDetails',
            	type: 'GET',
            },
            getSectors:{
              url: '/commonService/search/all/sectors',
              type: 'GET',
            },
            getCosmicExposureLimits:{
              url: '/commonService/search/cosmic/exposure/limits',
              type: 'GET',
            },
            getCabinPerformanceEditPrivilege:{
              url:'/commonService/privileges/edit/cabin/performance',
              type: 'GET',
            },


            loadLanguageList:{
                url: '/adminService/languages',
                type: 'GET'
            },
            searchFuelPrices: {
                url: '/adminService/search/fuel/price',
                type: 'POST'
            },
            saveFuelPrices: {
                url: '/adminService/save/fuel/price',
                type: 'POST'
            },
            deleteFuelPrices: {
                url: '/adminService/delete/fuel/price',
                type: 'POST'
            },
            searchFuelUplifts: {
            	url: '/adminService/search/fuelUplift',
                type: 'POST'
            },
            getAlertCategories: {
                url: '/commonService/alert/categories',
                type: 'GET'
            },
            getSendMsgMaxCharacterCount: {
                url: '/commonService/appParams/msg/maximum/character/count',
                type: 'GET'
            },
            getValidationTypes: {
                url: '/commonService/validation/types',
                type: 'GET'
            },
            loadValidations: {
                url: '/commonService/validations/byType',
                type: 'POST'
            },
            getACTypesByValidation: {
                url: '/commonService/search/acTypes/by/validation',
                type: 'POST'
            },
            getRuleDescList :{
            	url: '/commonService/search/rule/description',
                type: 'GET',
                pathParam: ['isHard']
            },
            getGMTOffSetValue: {
                url: '/commonService/appParams/gmtOffSetValue',
                type: 'GET'
            },
            getCurrency: {
                url: '/commonService/appParams/currency',
                type: 'GET'
            },
            getShowNewGDValue: {
                url: '/commonService/appParams/showNewGDValue',
                type: 'GET'
            },
            getAllCrewDisplayNameList: {
                url: '/commonService/search/all/crew/display/names',
                type: 'POST'
            },
            getNewAlertMsgCount: {
                url: '/commonService/get/new/alert/msg/count',
                type: 'GET'
            },
            getPrintSeparateGDForCrewTypes: {
                url: '/commonService/appParams/print/separate/gd/for/crewTypes/flag',
                type: 'GET'
            },
            loadResponseStatusList:{
            	url: '/commonService/load/responseStatusList',
                type: 'GET'
            },
            loadCrewStatusList:{
            	url: '/commonService/load/app/crewStatusList',
                type: 'GET'
            },
            getMissingReportStatusList:{
            	url :'/commonService/load/missingReport/status/list',
            	type: 'GET'
            },
            getFlightStatusList:{
            	url :'/commonService/load/report/flightStatusList',
            	type: 'GET'
            },
            getDivertedStatusList:{
            	url :'/commonService/load/report/divertedStatusList',
            	type: 'GET'
            },
            getAcRegistrationList:{
            	url :'/commonService/getAcRegistrations',
            	type: 'GET'
            },
            getDepartments:{
            	url :'/commonService/departments',
            	type: 'GET'
            },
            getVoyageDepartments:{
              url :'/commonService/voyage-departments',
              type: 'GET'
            },
            getReportPriviledges:{
            	url :'/commonService/priviledges/reports',
            	type: 'GET'
            },
            getImportPriviledges:{
            	url :'/commonService/priviledges/import/user',
            	type: 'GET'
            },
            getFlightEditPriviledge:{
              url :'/commonService/priviledges/flight/update',
              type: 'GET'
            },
            getCrewingPriviledges:{
            url :'/commonService/priviledges/crewing',
            type: 'GET'
          },
            getRightClickContextMenuPrivileges:{
              url :'/commonService/privileges/right/click/contextMenu',
              type: 'GET'
            },
            getAircraftModelList: {
              url: '/commonService/aircraft/modelList',
              type: 'GET'
            },

            getNightFlyForNightCredit: {
              url: '/commonService/appParams/pattern/nightCreditField/enable',
              type: 'GET'
            },
            getACModelCrewRequirement : {
              url: '/commonService/aircraft/model/crew/req',
              type: 'GET'
            },
            /*******************/
            /*FLEET SERVICE ENDPOINTS*/

            loadFlightAssignedCrew: {
                url: '/fleetService/flightAssignedCrew',
                type: 'GET',
                queryParam: ['flightLegId']
            },
            loadEventsForPairing: {
                url: '/pairingService/events',
                type: 'GET',
                headerParam: headers.showLoading,
                queryParam: ['selectedDate']
            },
            loadEventsForDate: {
                url: '/pairingService/events/date',
                type: 'GET',
                queryParam: ['selectedDate']
            },
            getAirCraftDetails: {
                url: '/fleetService/flightDetails',
                type: 'POST',
                headerParam: headers.showLoading
            },
            saveRotationDetails: {
                url: '/fleetService/save/rotation',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateTakeOffLanding: {
                url: '/fleetService/update/crew/information',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateFuelDetails: {
                url: '/fleetService/update/fuel/info',
                type: 'POST',
                headerParam: headers.showLoading
            },
            cancelOrReInstateFlight: {
                url: '/fleetService/cancelOrReinstateFlight',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateFlightPassengerDetails: {
                url: '/fleetService/update/passenger/info',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateFlightDetails: {
                url: '/fleetService/update/leg',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchFlightSchedule: {
                url: '/fleetService/search/rotation',
                type: 'POST',
                headerParam: headers.showLoading
            },
            doDailyRotation: {
                url: '/fleetService/do/daily/rotation',
                type: 'POST',
                headerParam: headers.showLoading
            },
            isPairingOpen: {
                url: '/pairingService/is/pairing/open',
                type: 'POST',
                headerParam: headers.showLoading
            },
            loadTrainingForPairing: {
                url: '/pairingService/trainings',
                type: 'POST'
            },
            searchOpenFlightSchedule: {
                url: '/fleetService/search/open/flights',
                type: 'POST'
            },
            searchFuelSuppliers: {
                url: '/fleetService/search/fuel/suppliers/info',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchFuelSuppliersForFuelUplift: {
              url: '/fleetService/search/fuel/suppliers/info/for/flight/uplift',
              type: 'POST',
              headerParam: headers.showLoading
            },
            deleteFuelSupplier: {
                url: '/fleetService/delete/fuel/supplier/info',
                type: 'POST',
                headerParam: headers.showLoading
            },
            saveFuelSupplier: {
                url: '/fleetService/save/fuel/supplier/info',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchFuelInfo: {
                url: '/fleetService/search/flight/fuel/info',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchFlight: {
                url: '/fleetService/search/flight',
                type: 'POST',
                headerParam: headers.showLoading
            },
            saveFlight:{
                url: '/fleetService/save/flight',
                type: 'POST',
                headerParam: headers.showLoading
            },
            sendRotationChangeEmail:{
                url: '/fleetService/send/rotation/change/email',
                type: 'POST',
                headerParam: headers.showLoading
            },
            sendRotationEmail:{
                url: '/fleetService/send/rotation/email',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getNextFullScheduleList:{
            	url: '/fleetService/next/full/schedule/period',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getFullScheduleListForRotationSummary:{
            	url: '/fleetService/full/schedule/periods/for/rotation/summary',
                type: 'GET',
                headerParam: headers.showLoading
            },
            getRotationSummary:{
            	url: '/fleetService/search/rotation/summary',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchSlotMessageSummary:{
              url: '/slotMessageService/slot/message/search',
              type: 'POST',
              headerParam: headers.showLoading
            },
            isShowSlotMessage: {
              url: '/commonService/appParams/isShowSlotMessage',
              type: 'GET'
            },
            isAutoPairingEnabled: {
              url: '/commonService/appParams/isAutoPairingEnabled',
              type: 'GET'
          },
          isRegulationWarningReportEnabled: {
            url: '/commonService/appParams/isRegulationWarningReportEnabled',
            type: 'GET'
          },
          isAutoAcknowledgementOfViewRosterEnabled: {
            url: '/commonService/appParams/isAutoAcknowledgementOfViewRosterEnabled',
            type: 'GET'
          },
            doFullScheduleRotation: {
                url: '/fleetService/do/full/rotation',
                type: 'POST',
                headerParam: headers.showLoading
            },
            loadSlotMessageByFlightLeg: {
                url: '/slotMessageService/slot/message',
                type: 'GET',
                queryParam: ['flightLegId', 'latestOnly']
            },
            loadMVTMessageByFlightLeg: {
              url: '/mvtMessageService/mvt/message',
              type: 'GET',
              queryParam: ['flightLegId']
            },
            isShowMVTMessage: {
              url: '/commonService/appParams/isShow/mvtMessage/inFlightWatch',
              type: 'GET'
            },
            sendFlightCrewNotifications: {
                url: '/flightCrewNotificationService/flight/crew/notification',
                type: 'POST',
                headerParam: headers.showLoading
            },
            loadDefaultMessagesByFlightLeg: {
                url: '/flightCrewNotificationService/flight/crew/notification/flightDetail',
                type: 'POST',
                headerParam: headers.showLoading
            },

            /*******************/
            /*CREWING ENDPOINTS*/

            searchMissingSignInData:{
            	 url: '/crewingService/search/missing/sign/in',
                 type: 'POST',
                 headerParam: headers.showLoading
            },
            getJoiningCrewList : {
            	url: '/crewingService/search/duty/joiningCrew',
            	type: 'POST',
            	headerParam: headers.showLoading
            },
            searchMissingSignOutData:{
           	 	url: '/crewingService/search/missing/sign/out',
                type: 'POST',
                headerParam: headers.showLoading
            },
            doSignIn:{
           	 	url: '/crewingService/do/sign/in',
                type: 'POST',
                headerParam: headers.showLoading
            },
            doSignOut:{
          	 	url: '/crewingService/do/sign/out',
               type: 'POST',
               headerParam: headers.showLoading
            },
            activateReport:{
            	url: '/crewingService/activate/report',
                type: 'POST',
                headerParam: headers.showLoading
            },
            extendDeadline:{
           	 	url: '/crewingService/extend/deadline',
                type: 'POST',
                headerParam: headers.showLoading
            },

            getFlightOccurringEvents: {
                url: '/crewingService/flight/events',
                type: 'GET',
                queryParam: ['selectedDate']
            },
            deleteMemo: {
                url: '/crewingService/delete/Memo/',
                type: 'GET',
                queryParam: ['crewSchdMemoId', 'version']
            },
            getBlockAssignedCrew: {
                url: '/crewingService/block/assigned/crew',
                type: 'GET',
                headerParam: headers.showLoading,
                queryParam: ['crewSchedBlockId']
            },
            getEditEventDetails: {
                url: '/crewingService/edit/eventDetails',
                type: 'GET',
                headerParam: headers.showLoading,
                queryParam: ['crewSchedBlockId']
            },
            checkGenderWarningByPatternId: {
                url: '/crewingService/pattern/assign/gender/warning',
                type: 'GET',
                pathParam: ['patternId', 'crewProfileId'],
                headerParam: headers.showLoading
            },
            checkGenderWarningByCrewScheduleId: {
                url: '/crewingService/pattern/unassign/gender/warning',
                type: 'GET',
                pathParam: ['crewScheduleId', 'crewProfileId'],
                headerParam: headers.showLoading
            },
            unAssignBlock: {
                url: '/crewingService/unAssign/block',
                type: 'POST',
                headerParam: headers.showLoading
            },
            emailCrewSchedule: {
                url: '/crewingService/emailCrewSchedule',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchPatternData: {
                url: '/crewingService/search/pattern',
                type: 'POST'
            },
            swap: {
                url: '/crewingService/swap',
                type: 'POST',
                headerParam: headers.showLoading
            },
            assignPatternForSby: {
              url: '/crewingService/sby/call/out',
              type: 'POST',
              headerParam: headers.showLoading
            },
            assignPattern: {
                url: '/crewingService/assign/pattern',
                type: 'POST',
                headerParam: headers.showLoading
            },
          swapPattern: {
            url: '/crewingService/swap/pattern',
            type: 'POST',
            headerParam: headers.showLoading
          },
            assignTraining: {
                url: '/crewingService/assign/training',
                type: 'POST',
                headerParam: headers.showLoading
            },
            assignEvent: {
                url: '/crewingService/assign/event',
                type: 'POST',
                headerParam: headers.showLoading
            },
            replacePattern: {
              url: '/crewingService/replace/pattern',
              type: 'POST',
              headerParam: headers.showLoading
            },
            getRegulation: {
                url: '/crewingService/showRegulations',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getHistory: {
                url: '/crewingService/showHistory',
                type: 'POST',
                headerParam: headers.showLoading
            },
            cutPasteDuty: {
                url: '/crewingService/cutPaste',
                type: 'POST',
                headerParam: headers.showLoading
            },
            copyPasteDuty: {
                url: '/crewingService/copyPaste',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getTrainings: {
                url: '/crewingService/training/schedule',
                type: 'POST',
                headerParam: headers.showLoading
            },
            saveMemo: {
                url: '/crewingService/saveMemo',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateCheckInCheckout: {
                url: '/crewingService/editBlock/chekInCheckOut',
                type: 'POST',
                headerParam: headers.showLoading
            },
            editEvent: {
                url: '/crewingService/edit/event',
                type: 'POST',
                headerParam: headers.showLoading
            },
            checkIsPublished: {
                url: '/crewingService/isPublished',
                type: 'POST',
                headerParam: headers.showLoading
            },
            checkIsPublishedByCrewProfileId: {
              url: '/crewingService/isPublished/crew-profile-ids',
              type: 'POST',
              headerParam: headers.showLoading
            },
            schedulePublish: {
                url: '/crewingService/publish',
                type: 'POST',
                headerParam: headers.showLoading
            },
            assignDirectEvent: {
                url: '/crewingService/assign/direct/event',
                type: 'POST',
                headerParam: headers.showLoading
            },
            assignOfcDirectEvent: {
              url: '/crewingService/assign/direct/ofc/event',
              type: 'POST',
              headerParam: headers.showLoading
            },
            sendSMS: {
                url: '/crewingService/send/sms',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchSMSList :{
           		url : '/smsManagerService/search/sms',
           		type : 'POST',
           		headerParam: headers.showLoading
           	},
            getSmsManagerStatus: {
              url: '/smsManagerService/search/message/status',
              type: 'GET'
            },
            sendAlert: {
                url: '/crewingService/send/alert',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getBlockDetail: {
                url: '/crewingService/block/detail',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getBlockDetailTraining: {
              url: '/crewingService/block/detail/training',
              type: 'POST',
              headerParam: headers.showLoading
            },
            searchCrewSchedule: {
                url: '/crewingService/search/schedules',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchCrewExpiries: {
                url: '/crewingService/search/crew/expiries',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateTrainingProgram: {
                url: '/crewingService/editBlock/trainingProgram',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateTakeOffLandingInfo: {
              url: '/crewingService/editBlock/takeOffLanding',
              type: 'POST',
              headerParam: headers.showLoading
            },
            updateTrainerTrainee: {
                url: '/crewingService/update/traininerTrainee',
                type: 'POST',
                headerParam: headers.showLoading
            },
            checkLanguageWarning: {
                url: '/crewingService/language/warning',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateExpiryBlock: {
                url: '/crewingService/edit/block/update/expiry',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateExpiryMultipleTrainings: {
              url: '/crewingService/edit/block/update/multiple/expiries',
              type: 'POST',
              headerParam: headers.showLoading
            },
            updateExpiryFlight: {
                url: '/crewingService/edit/block/update/flight/expiry',
                type: 'POST',
                headerParam: headers.showLoading
            },
            filterCrewSchedule: {
                url: '/crewingService/filter/crew/schedules',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateCrewScheduleBlockFlags: {
                url: '/crewingService/update/crew/schedule/block/flags',
                type: 'POST',
                headerParam: headers.showLoading
            },
            showAllHideCrewScheduleBlocks: {
                url: '/crewingService/show/all/hide/crew/schedule/blocks',
                type: 'POST',
                headerParam: headers.showLoading
            },
            checkDistributionWarning:{
                url: '/crewingService/check/distribution/identifier/violation',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchCreditHoursDetails:{
                url: '/crewingService/load/credit/hours',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchTrainingStagesDetails:{
              url: '/crewingService/crewTrainingStages',
              type: 'GET',
              headerParam: headers.showLoading,
              queryParam: ['crewProfileId','toDate']
            },
            syncTrainingStages:{
              url: '/crewingService/crewTrainingStages/calculate',
              type: 'POST',
              headerParam: headers.showLoading
            },
            getCrewRequirementsByPairingId:{
                url: '/crewingService/search/crewRequirementsByPairingId',
                type: 'POST',
                headerParam: headers.showLoading
            },
            saveCrewRequirementsByPairingId:{
                url: '/crewingService/save/crewRequirementsByPairingId',
                type: 'POST',
                headerParam: headers.showLoading
            },
            acknowledgeDuty: {
                url: '/crewingService/acknowledge/block',
                type: 'POST',
                headerParam: headers.showLoading
            },
            convertToSick: {
              url: '/crewingService/convert/sick',
              type: 'POST',
              headerParam: headers.showLoading
            },

            checkDutyPrevNextBase:{
              url: '/crewingService/duty/previousBase/validation',
              type: 'POST',
              headerParam: headers.showLoading
            },

            getLimitationWarnings: {
              url: '/crewingService/search/crew/flyingHours',
              type: 'POST'
            },

            /*******************/
            /*PAIRING ENDPOINTS*/
            loadTrainingProgramDetails: {
                url: '/pairingService/trainingProgDetail',
                type: 'GET',
                queryParam: ['trainingId']
            },
            loadLanguageReqByPattern: {
                url: '/pairingService/search/languageByPatternId',
                type: 'GET',
                queryParam: ['patternId']
            },
            loadGenderReqByPattern: {
            url: '/pairingService/search/genderByPatternId',
            type: 'GET',
            queryParam: ['patternId']
            },
            loadCrewReqByPattern: {
                url: '/pairingService/patternAssignedCrew',
                type: 'GET',
                queryParam: ['patternId']
            },
             loadCrewReqByPatternOnly: {
                url: '/pairingService/patternAssignedCrewOnly',
                type: 'GET',
                queryParam: ['patternId']
            },
            loadTrainingProgram: {
                url: '/pairingService/trainingProg',
                type: 'GET',
                queryParam: ['trainingSlotId']
            },
            loadPatternNames: {
                url: '/pairingService/pattern/names',
                type: 'GET',
                queryParam: ['fromDate', 'toDate']
            },
          loadRosterPatternNames : {
              url : '/pairingService/pattern/roster/names',
             type: 'GET',
            queryParam : ['cycleId', 'crewType']
          },
            getPatternById: {
                url: '/pairingService/pattern',
                type: 'GET',
                pathParam: ['patternID']
            },
            deletePattern: {
                url: '/pairingService/delete/patterns',
                type: 'POST',
                headerParam: headers.showLoading
            },
            remoteFDPValidation: {
                url: '/pairingService/pattern/fdpValidate',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchPairing: {
                url: '/pairingService/search/patterns',
                type: 'POST',
                headerParam: headers.showLoading
            },
            loadLanguageByAirports: {
                url: '/pairingService/langReqByAirport',
                type: 'POST',
                headerParam: headers.showLoading
            },
            savePairing: {
                url: '/pairingService/save/pairing',
                type: 'POST',
                headerParam: headers.showLoading
            },
            saveCrewComplement: {
                url: '/pairingService/save/crewComplement',
                type: 'POST',
                headerParam: headers.showLoading
            },
            syncCrew: {
                url: '/pairingService/sync/crew',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchOpenPairings: {
                url: '/pairingService/search/openPairing',
                type: 'POST'
            },
            loadFlightForPairing: {
                url: '/pairingService/flights',
                type: 'POST'
            },
          savePairingAudit: {
              url: '/pairingService/pairing/audit',
              type: 'POST'
            },
            loadPatternNamesByCrewTypeCode : {
				        url : '/pairingService/patterns/by/crewType',
				        type : 'GET',
				        queryParam : [ 'crewTypeCode' ]
			      },

			      loadPatternDurationTypes:{
				        url:'/pairingService/pattern/durationTypes',
				        type : 'GET'
			      },

			      loadPatternDepartureTypes:{
				        url:'/pairingService/pattern/departureTypes',
				        type : 'GET'
			      },
			      loadPatternNamesByCrewTypeAndReqDate : {
				        url:'/pairingService/patterns/by/crew/type/and/req/date',
				        type : 'GET',
				        queryParam : [ 'crewTypeCode', 'requestDate' ]
			      },
            sendDeadHeadTravelRequest :{
                url:'/pairingService/send/deadhead/travel/request',
                type : 'POST',
                headerParam: headers.showLoading
            },
          sendOverrideTravelRequest :{
                url:'/pairingService/send/deadhead/travel/override',
                type : 'POST',
                headerParam: headers.showLoading
            },
          isNonACMICrewAvailableInPattern : {
              url:'/pairingService/pattern/isNonACMICrewAssigned',
              type : 'GET',
              queryParam : [ 'patternId' ,'startDate']
            },

            searchFlyingMinutes : {
                url:'/pairingService/search/flyingMinutes',
                type : 'POST'
            },

            /*******************/
            /*CREW SCHEDULE ENDPOINTS*/
            searchCrewPublishSchedule: {
                url: '/crewingService/search/publish/schedule',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getCrewImgUrl: {
                url: '/crewService/search/profile/image/url',
                type: 'GET',
                queryParam: ['crewProfileId']
            },
            getCrewImgDataUrl: {
                url: '/crewService/search/profile/image',
                type: 'GET',
                queryParam: ['crewProfileId'],
                responseType: 'blob'
            },
            loadCrewAirportsExclusion: {
                url: '/crewService/search/crew/airports/exclusion',
                type: 'GET',
                queryParam: ['crewProfileId']
            },
            searchTotalOtherHubData: {
                url: '/crewService/search/groupTotalHoursData',
                type: 'POST',
                headerParam: headers.showLoading
            },
            loadCrewExclusion: {
                url: '/crewService/search/crewExclusion',
                type: 'POST',
                headerParam: headers.showLoading
            },
            viewCrewNotes: {
                url: '/trackingService/search/crewSheduleNote',
                type: 'POST'
            },
            addEditNotes: {
                url: '/trackingService/save/crewSheduleNote ',
                type: 'POST',
                headerParam: headers.showLoading
            },
            deleteCrewScheduleNote: {
                url: '/trackingService/delete/crewSheduleNote',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchRenewals : {
           		url : '/crewService/search/expired/crew',
           		type : 'POST',
           		headerParam: headers.showLoading
           	},
          getAnnualLeaveBiddingResponse: {
            url: '/crewingService/get/annualLeaveBiddingResponse',
            type: 'POST',
            headerParam: headers.showLoading
          },

            getBlankDays: {
                url : '/trackingService/search/crewViolations/getBlankDays',
                type : 'POST',
                headerParam: headers.showLoading
            },
            getFdpPendingCrewSchedules: {
              url: '/crewingService/search/fdpProcessingDuties',
              type: 'POST'
            },

            /*******************/
            /* CREW PROFILE ENDPOINTS*/
            civilIdStatus: {
              url:'/commonService/appParams/isShowCivilId',
              type: 'GET'
            },
            searchCrewProfile: {
                url: '/crewService/search/crewData',
                type: 'GET',
                queryParam: ['crewId']
            },
            editSaveCrewProfile: {
                url: '/crewService/save/crewProfile',
                type: 'POST',
                headerParam: headers.showLoading
            },
            editDeleteExclusion: {
                url: '/crewService/save/exclusion ',
                type: 'POST',
                headerParam: headers.showLoading
            },
            editDeleteInclusion: {
              url: '/crewService/save/inclusion',
              type: 'POST',
              headerParam: headers.showLoading
            },
            managementCrewPositions: {
                url: '/crewService/managementCrewPositions',
                type: 'GET'
            },
            getLanguageSkillsData: {
                url: '/crewService/search/crew/language/skill',
                type: 'GET',
                queryParam: ['crewProfileId']
            },
            getTrainerTypes: {
                url: '/crewService/trainerTypes',
                type: 'GET'
            },
            getFleetExperience: {
                url: '/crewService/search/fleetExperience',
                type: 'POST'
            },
            addEditFleetExperience: {
                url: '/crewService/save/fleetExperience',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getCrewPaymentDetails: {
                url: '/crewService/search/crew/payments/details',
                type: 'GET',
                queryParam: ['crewProfileId']
            },
            getCrewPaymentRangeDetails : {
                url: '/crewService/search/crew/payment/hour/ranges',
                type: 'GET',
                queryParam: ['crewProfileId'],
                headerParam: headers.showLoading
            },
            getCrewOtherPaymentDetails : {
                url: '/crewService/search/crew/other/payment/rates',
                type: 'GET',
                queryParam: ['crewProfileId'],
                headerParam: headers.showLoading
            },
            saveCrewPaymentRangeDetails : {
                url: '/crewService/save/crew/payment/hour/ranges',
                type: 'POST',
                headerParam: headers.showLoading
            },
            saveCrewOtherPaymentRates: {
                url: '/crewService/save/crew/other/payment/rates',
                type: 'POST',
                headerParam: headers.showLoading
            },
            deleteCrewPaymentRangeDetail: {
                url: '/crewService/delete/crew/payment/hour/range',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updatePaymentInfo: {
                url: '/crewService/save/crew/payments/details',
                type: 'POST',
                headerParam: headers.showLoading
            },
            crewUpgradeData: {
                url: '/crewService/search/crewUpgradeData',
                type: 'POST'
            },
            getCrewTrainingStages: {
              url: '/crewService/search/crew-type-stage/by-crew-profile',
              type: 'POST'
            },
            addEditTrainingStage: {
              url: '/crewService/crew-type-stage/by-crew-profile',
              type: 'POST',
              headerParam: headers.showLoading
            },
            updateTrainingStageStatus: {
              url: '/crewingService/crewTrainingStages/result',
              type: 'POST',
              headerParam: headers.showLoading
            },
            crewPunctualityData : {
              url: '/crewService/search/crew/punctuality/summary',
              type: 'POST'
            },
            crewHistoryData : {
              url: '/crewService/search/crew/profile/history',
              type: 'POST'
            },
            addEditCrewUpgradeData: {
                url: '/crewService/save/upgradeData',
                type: 'POST',
                headerParam: headers.showLoading
            },
            deleteCrewUpgradeData: {
                url: '/crewService/delete/upgradeData',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchCrewExclusion: {
                url: '/crewService/search/crewExclusion',
                type: 'POST'
            },
            searchAirportExclusion: {
                url: '/crewService/search/crew/airports/exclusion',
                type: 'GET',
                queryParam: ['crewProfileId']
            },
            searchAirportInclusion: {
              url: '/crewService/search/crew/airports/inclusion',
              type: 'GET',
              queryParam: ['crewProfileId']
            },
            searchHoursData: {
                url: '/crewService/search/hoursData',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getCrewDefaultValidation: {
                url: '/crewService/search/crew/default/validation',
                type: 'GET',
                queryParam: ['crewProfileId']
            },
            saveCrewDefaultValidation: {
                url: '/crewService/save/crew/default/validation',
                type: 'POST'
            },
            getCrewTypeDefaultValidation: {
                url: '/crewService/search/crewType/default/validation',
                type: 'GET',
                queryParam: ['crewTypeCode']
            },
            saveHoursData: {
                url: '/crewService/save/hoursData',
                type: 'POST',
                headerParam: headers.showLoading
            },
            savePreferenceData: {
                url: '/crewService/save/preferenceData',
                type: 'POST',
                headerParam: headers.showLoading
            },
            deleteHoursData: {
                url: '/crewService/delete/crewHubFlyingHours',
                type: 'POST',
                headerParam: headers.showLoading
            },
            deletePreferenceData: {
                url: '/crewService/delete/layoverAccommodationPreference',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getHubDetails: {
                url: '/adminService/crew/FlyingHour/Hubs',
                type: 'GET'
            },
            getHubs: {
                url: '/adminService/hubs',
                type: 'GET'
            },
            getCrewValidations: {
                url: '/crewService/search/crewValidations',
                type: 'POST',
                headerParam: headers.showLoading
            } ,
            saveCrewValidation: {
                url: '/crewService/save/crewValidation',
                type: 'POST'
            },
            deleteCrewValidation: {
                url: '/crewService/delete/crewValidation',
                type: 'POST'
            },
            getCrewBaseAssignment: {
                url: '/crewService/search/last3crewBaseAssignment',
                type: 'POST'
            },
            getEffectedBaseList: {
                url: '/crewService/search/effectedBaseList',
                type: 'POST'
            },
            getAllCrewBaseAssignment: {
                url: '/crewService/search/crewBaseAssignment',
                type: 'POST'
            },
            getAllCrewLayoverAccommodationPreferences: {
                url: '/crewService/search/crewLayoverAccommodationPreferencesHistory',
                type: 'GET',
                pathParam: ['crewProfileId'],
                headerParam: headers.showLoading
            },
            getRosterSummary: {
                url: '/crewService/search/rosterSummary',
                type: 'POST'
            },
          getFlyingHoursSummaryData: {
            url: '/crewService/search/crew/consolidated/flying/summary',
            type: 'POST',
            headerParam: headers.showLoading
          },
            addEditCrewBase: {
                url: '/crewService/save/crewBaseAssignment',
                type: 'POST',
                headerParam: headers.showLoading
            },
            addEditCrewSecondaryBase: {
                url: '/crewService/save/crewSecondaryBaseAssignment',
                type: 'POST',
                headerParam: headers.showLoading
            },
            deleteCrewBaseRemote: {
                url: '/crewService/delete/crewBaseAssignment',
                type: 'POST',
                headerParam: headers.showLoading
            },
            deleteSecondaryCrewBaseRemote: {
                url: '/crewService/delete/crewSecondaryBaseAssignment',
                type: 'POST',
                headerParam: headers.showLoading
            },
          addEditPositionDateRange: {
            url: '/crewService/save/positionDateRange',
            type: 'POST',
            headerParam: headers.showLoading
          },
          deletePositionDateRange: {
            url: '/crewService/delete/positionDateRange',
            type: 'POST',
            headerParam: headers.showLoading
          },
            crewBaseAssignmentByDate: {
                url: '/crewService/search/crewBaseAssignmentByDate',
                type: 'POST',
                headerParam: headers.showLoading
            },
            loadAllAppParamList: {
                url: '/adminService/search/all/application/parameters',
                type: 'POST'
            },
            saveAppParams: {
                url: '/adminService/save/application/parameters',
                type: 'POST'
            },
            searchGridCircularDistance : {
                url: '/adminService/search/grid/circular/distance',
                type: 'POST',
                headerParam: headers.showLoading
            },
            saveGridCircularDistance : {
                url: '/adminService/save/grid/circular/distance',
                type: 'POST',
                headerParam: headers.showLoading
            },
            deleteGridCircularDistance : {
                url: '/adminService/delete/grid/circular/distance',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchFlightCargo : {
                url: '/flightService/search/flightCargo',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateFlightCargo : {
                url: '/flightService/update/flightCargo',
                type: 'POST',
                headerParam: headers.showLoading
            },
            navigatesToAeroOps :{
                url: '/fleetService/navigete/to/aeroops',
                type: 'GET'
            },
            searchDepartureFlightData:{
            	url: '/flightPunctualityService/search/punctuality/flights/departure',
            	type: 'POST',
            	headerParam: headers.showLoading
            },
          searchStationFlightHandlingData:{
            url: '/stationFlightHandler/search/flight',
            type: 'POST',
            headerParam: headers.showLoading,
          },
          updateStationFlightHandlingData:{
            url: '/stationFlightHandler/flights',
            type: 'POST',
            headerParam: headers.showLoading,
          },
          getStationFlightHandlingStationForSearch:{
            url: '/commonService/station/airport',
            type: 'GET',
            headerParam: headers.showLoading,
          },
          getStationFlightHandlingAuditData:{
            url: '/stationFlightHandler/history',
            type: 'GET',
            headerParam: headers.showLoading,
            queryParam: ['flightLegId']
          },
            searchArrivalFlightData:{
            	url: '/flightPunctualityService/search/punctuality/flights/arrival',
            	type: 'POST',
            	headerParam: headers.showLoading
            },
            searchIntermediateFlightData:{
            	url: '/flightPunctualityService/search/punctuality/flights/intermediate',
            	type: 'POST',
            	headerParam: headers.showLoading
            },
            searchJoiningCrewsForFlight:{
            	url: '/flightPunctualityService/search/flight/joining/crew',
            	type: 'GET',
              headerParam: headers.showLoading,
            	pathParam: ['flightLegId']
            },
            getEnableRosterTabFromProfile: {
                url:'/commonService/appParams/enableRoster/inProfile',
                type: 'GET'
            },
            getMealDetails: {
              url:'/flightService/search/mealDetails',
              type: 'POST',
              headerParam: headers.showLoading
            },
            getFlightLogDetails:{
              url: '/flightPunctualityService/search/punctuality/flight/log',
              type: 'GET',
              headerParam: headers.showLoading,
              pathParam: ['flightLegId']
            },
            sendLIDOWABMessage:{
              url: '/flightPunctualityService/send/punctuality/lido/wab',
              type: 'GET',
              pathParam: ['flightLegId']
            },
            updateAdHocAtcCallSign : {
              url: '/atcCallSignService/atc/call-sign/ad-hoc/update',
              type: 'POST',
              headerParam: headers.showLoading
            },
            isSetDefaultBase: {
                url:'/commonService/appParams/isSetDefaultBase',
                type: 'GET'
            },
            getAlvGroups:{
              url: '/crewService/alvGroups',
              type: 'GET',
              queryParam: ['crewType']
            },

            //
            /*******************/
            /*IMPORT SERVICE ENDPOINTS*/
            importHoursData: {
                url: '/importService/import/otherHubHrs',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getAutoImportAllowedClients: {
                url: '/importService/search/availableHubsForImport',
                type: 'GET'
            },
            /*******************/
            /*TRAINING PROGRAMS ENDPOINTS*/
            searchTrainingPrograms: {
                url: '/trainingService/search/trainingPrograms',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchTrainingSubPrograms: {
                url: '/pairingService/training/prog/details',
                type: 'GET',
                headerParam: headers.showLoading
            },

            saveTrainingPrograms: {
                url: '/trainingService/save/trainingPrograms',
                type: 'POST',
                headerParam: headers.showLoading
            },
            reSyncOtherHubTrainings: {
                url: '/trainingService/reSync/otherHub/trainings',
                type: 'POST',
                headerParam: headers.showLoading
            },
            deleteTrainingPrograms: {
                url: '/trainingService/delete/trainingPrograms',
                type: 'POST',
                headerParam: headers.showLoading
            },
            /*******************/
            /*TRAINING SCHEDULE ENDPOINTS*/
            searchTrainingSchedule: {
                url: '/trainingService/search/schedule ',
                type: 'POST',
                headerParam: headers.showLoading
            },
            updateTrainingSchedule: {
                url: '/trainingService/update/training/schedule ',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getTrainingBySlotID:{
                url: '/trainingService/search/schedule/by/training/slot',
                type: 'POST',
                headerParam: headers.showLoading
            },
            // get crew list based on expiry details and crew details
            getCrewList: {
                url: '/trainingService/search/schedule/crewData ',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getAvailableTraining: {
                url: '/trainingService/scheduled/trainings',
                type: 'POST',
                headerParam: headers.showLoading
            },
            assignTrainerTrainee: {
                url: '/trainingService/assign/trainer/trainee ',
                type: 'POST',
                headerParam: headers.showLoading
            },
            assignTrainerTraineeBulk: {
              url: '/trainingService/assign/trainer/trainee/bulk',
              type: 'POST',
              headerParam: headers.showLoading
            },
            unAssignTrainerTrainee: {
                url: '/trainingService/unAssign/trainer/trainee ',
                type: 'POST',
                headerParam: headers.showLoading
            },
            unAssignExternalTrainee:{
            	url: '/trainingService/unAssign/external/trainee ',
                type: 'POST',
                headerParam: headers.showLoading
            },
            searchTrainingProgramAssignedTrainingSlots: {
                url: '/trainingService/search/program/assigned/training/slots',
                type: 'POST'
            },
            getCrewRequirement: {
                url: '/trainingService/crewRequirement/',
                type: 'GET',
                queryParam: ['trainingSlotId']
            },
            /*Tracking api endpoints*/
            searchTrackingFlight: {
                url: '/trackingService/search/tracking/flights',
                type: 'POST',
                headerParam: headers.showLoading
            },
            getRequiredGenderCountsForPattern: {
                url: '/trackingService/assigned/gender/count/for/pattern',
                type: 'POST'
            },
            getSugestedCrewList: {
                url: '/trackingService/search/crew/suggestion',
                type: 'POST'
            },
            getAllDiscrepanciesByFlightLegId : {
                url : '/trackingService/all/discrepancy/by/flightLegId',
                type : 'POST'
            },
            getPairingsByFlightLegId: {
                url: '/trackingService/flight/pairings',
                type: 'GET',
                queryParam: ['flightLegId']
            },
            getSuggestedCrewBySlot:{
                url: '/trainingService/training/required/crews',
                type: 'GET',
                pathParam: ['trainingSlotId']
            },
            /*******************/
            /*ROSTER SCHEDULE ENDPOINTS*/
            getRosterCycles: {
                url : '/rosterService/search/cycles',
                type : 'GET',
                queryParam: ['showAll']
            },
            loadRosterSchedules: {
                url : '/rosterService/search/autoSchedule',
                type : 'POST'
            },
            loadRosterSchedulesCheckCSB: {
                url : '/rosterService/search/autoScheduleCheckCSB',
                type : 'POST'
            },
            loadTrainerTraineeList : {
                url : '/rosterService/search/trainer/crew',
                type : 'GET',
                queryParam: ['crewType']
            },
            loadStrategies: {
              url: '/rosterService/search/strategies',
              type: 'GET'
            },
            saveAutoRosterSchedule: {
                url : '/rosterService/save/autoSchedule',
                type : 'POST'
            },
            changeStatusAutoRosterSchedule: {
                url : '/rosterService/change/status/autoSchedule',
                type : 'POST'
            },
            deleteAutoRosterDistribution: {
                url : '/rosterService/delete/autoRoster/distribution',
                type : 'POST'
            },
            loadAdminCycles: {
                url : '/rosterService/search/cycles',
                type : 'GET',
                queryParam: ['showAll']
            },
            saveAdminCycle: {
                url : '/rosterService/save/cycles',
                type : 'POST'
            },
            deleteAdminCycle: {
                url : '/rosterService/delete/cycle',
                type : 'POST'
            },
            getPatternLimitations: {
                url : '/rosterService/autoSchedule/limitations',
                type : 'POST'
            },
            deletePatternLimitation: {
                url : '/rosterService/delete/patternLimitation',
                type : 'POST'
            },
            savePatternLimitation: {
                url : '/rosterService/save/pattern/limitation',
                type : 'POST'
            },

            searchBiddingDetails: {
                url : '/rosterService/search/bidding/details',
                type : 'POST',
                headerParam: headers.showLoading
            },

            assignBiddingRequest: {
                url : '/rosterService/assign/bidding/requests',
                type : 'POST',
                headerParam: headers.showLoading
            },
            saveNewBidRequest : {
            	 url : '/rosterService/save/bidding',
                 type : 'POST',
                 headerParam: headers.showLoading
            },
            searchRequestPriorities : {
            	 url : '/rosterService/search/request/priority',
                 type : 'GET'
            },
            searchDistributionConfigs:{
           		url : '/rosterService/search/distribution/configs',
           		type : 'POST',
           	 headerParam: headers.showLoading
           	},
           	saveDistributionConfig:{
           		url : '/rosterService/save/configure/distribution',
           		type : 'POST',
           	    headerParam: headers.showLoading
           	},

           	deleteDistributionConfig : {
           		url : '/rosterService/delete/configure/distributions',
           		type : 'POST',
           	    headerParam: headers.showLoading
           	},
           	searchDistributionConfigIdentifiers : {
           		url : '/rosterService/distribution/identifiers',
           		type : 'GET',
           	    headerParam: headers.showLoading
           	},
            searchActiveDistributionConfigIdentifiers : {
              url : '/rosterService/distribution/activeIdentifiers',
              type : 'GET',
              headerParam: headers.showLoading
            },
           	deleteCrewBiddings : {
           		url : '/rosterService/delete/crew/biddings',
           		type : 'POST',
           	    headerParam: headers.showLoading
           	},
           	getCycleFromDate : {
                url : '/rosterService/getCycleFromDate',
                type : 'POST',
                headerParam: headers.showLoading
            },

            /*******************/
            /*DOCUMENT MANAGER*/
            downloadDocument: {
                url: '/adminService/download/document',
                type : 'POST',
                headerParam: headers.showLoading
            },

            loadDocuments: {
                url : '/adminService/search/documentList',
                type : 'POST',
                headerParam: headers.showLoading
            },
            loadAllDownloadCategory:{
                url : '/adminService/getAllDownloadCats',
                type : 'GET'
            },
            deleteDocument: {
                url : '/adminService/delete/documentList',
                type : 'POST',
                headerParam: headers.showLoading
            },
            /******************/
            /*MASTER DATE ENDPOINTS*/
            searchCrewBatch: {
                url : '/adminService/search/batch',
                type : 'POST'
            },
            saveCrewBatch : {
                url : '/adminService/saveEdit/batch',
                type : 'POST'
            },
            deleteCrewBatch : {
                url : '/adminService/delete/batch',
                type : 'POST'
            },

            /*AIRCTAFT REGISTRATION ENDPOINTS*/
            searchAircraftRegistration:{
                url : '/adminService/search/aircraftRegistrations',
                type : 'POST',
           		headerParam: headers.showLoading
            },
            saveAircraftRegistration :{
                url : '/adminService/save/aircraftRegistration',
                type : 'POST',
           		headerParam: headers.showLoading
            },
            deleteAircraftRegistration :{
                url : '/adminService/delete/aircraftRegistration',
                type : 'POST',
           		headerParam: headers.showLoading
            },
            getCapacity: {
                url : '/adminService/model/capacity',
                type : 'GET',
                queryParam: ['modelNumber']
            },

            /*PAIRING COMPLIMENTS ENDPOINTS*/
            searchPairingCompliments:{
              url : '/pairingService/search/pairingCompliments',
              type : 'POST',
              headerParam: headers.showLoading
            },
            savePairingCompliments :{
              url : '/pairingService/save/pairingCompliments',
              type : 'POST',
              headerParam: headers.showLoading
            },
            deletePairingComplimentsInfo :{
              url : '/pairingService/delete/pairingCompliments',
              type : 'POST',
              headerParam: headers.showLoading
            },

            /* MANAGE ROLE ENDPOINTS*/
            searchManageRoles :{
                url : '/adminService/search/roles',
                type : 'POST'
            },
            getAdminRoleNames : {
                url : '/adminService/search/role/namesAndIds',   
                type : 'GET',
            },
            saveRole :{
                url : '/adminService/save/role',
                type : 'POST'
            },
            deleteRole :{
                url : '/adminService/delete/role',
                type : 'POST'
            },


            searchUserTypes : {
                url : '/adminService/search/user/types',
                type : 'GET'
            },
            searchUsers : {
                url : '/adminService/search/users',
                type : 'POST'
            },


            /*ALERT SERVICE ENDPOINTS*/
            searchAlerts: {
                url : '/alertService/search/alert',
                type : 'POST',
                headerParam: headers.showLoading
            },
            markAsInform: {
                url : '/alertService/mark/alertsAsInformed',
                type : 'POST'
            } ,
          getAlertCreatedByList: {
            url: '/alertService/get/alert/createdBy/list',
            type: 'GET',
            headerParam: headers.showLoading
          },
          getAlertTemplateCodeList: {
            url: '/alertService/get/alert/templateCode/list',
            type: 'GET',
            headerParam: headers.showLoading
          },

            searchRoles : {
                url : '/adminService/search/roles',
                type : 'POST',
                headerParam: headers.showLoading
            },
            searchUserNamesByCrewType : {
                url : '/search/user/name/by/crew/types',
                type : 'GET'
            },
            deleteUser :{
                url : '/adminService/delete/user',
                type : 'POST'
            },
            saveUser :{
                url : '/adminService/save/user',
                type : 'POST',
                headerParam: headers.showLoading
            },

            /*CONFIG TRACKING COLOR END POINTS*/
            searchTrackingColors:{
                url : '/adminService/search/tracking/colors',
                type : 'GET',
                queryParam: ['type']
            },
            saveTrackingColor :{
                url : '/adminService/save/tracking/colors',
                type : 'POST'
            },
            searchAirports : {
                url : '/adminService/search/airports',
                type : 'POST'
            },
            searchAirportCategories : {
                url : '/adminService/search/airport/categories',
                type : 'GET'
            },
            deleteAirportInfo :{
                url : '/adminService/delete/airport',
                type : 'POST'
            },saveAirport : {
                url : '/adminService/save/airport',
                type : 'POST'
            },
            /*TRAINING DESCREPANCY END POINTS*/
            searchTrainingDescrepancy :{
                url : '/trainingService/search/descrepency',
                type : 'POST',
                headerParam: headers.showLoading
           	},
           	/*REGULATION ENDPOINTS*/
           	searchRegulations :{
           		url : '/rosterService/autoSchedule/regulations',
           		type : 'POST'
           	},
           	saveRegulations :{
           		url : '/rosterService/update/regulation',
           		type : 'POST'
           	},

            /*******************/
            /*DUTY SHEET ENDPOINTS*/
           	searchDuties :{
           		url : '/dutySheetService/duty/sheet',
           		type : 'POST',
           		headerParam: headers.showLoading
           	},
           	searchDutiesLegality :{
           		url : '/dutySheetService/duty/sheet/validate/legality',
           		type : 'POST'
           	},
           	searchStandByDetails :{
           		url : '/dutySheetService/search/standbyDetails',
           		type : 'POST',
           		headerParam: headers.showLoading
           	},
           	searchDeadHeadingDetails:{
           		url : '/dutySheetService/search/dead-heading/details',
           		type : 'POST',
           		headerParam: headers.showLoading
           	},
           	searchReadyToWorkDetails :{
           		url : '/dutySheetService/search/readyToWorkDetails',
           		type : 'POST',
           		headerParam: headers.showLoading
           	},
            searchReportSickDetails :{
              url : '/dutySheetService/search/sickReportedCrewDetails',
              type : 'POST',
              headerParam: headers.showLoading
            },
           	searchOtherDutyTypeDetails :{
           		url : '/dutySheetService/get/otherDutyTypeEventDetails',
           		type : 'POST',
           		headerParam: headers.showLoading
           	},
           	sendEmail : {
           		url : '/dutySheetService/email',
           		type : 'POST',
           		headerParam: headers.showLoading
           	},
            loadGD: {
                url : '/dutySheetService/getGdData',
                type : 'POST',
                headerParam: headers.showLoading
            },
            getJourneyLogData:{
            	url : '/dutySheetService/get/journeyLogDetails',
                type : 'POST',
                headerParam: headers.showLoading
            },
            updateCheckedBy :{
            	url : '/dutySheetService/journeyLog/update/checkeBy',
                type : 'GET',
                queryParam: ['blockId','version'],
                headerParam: headers.showLoading
            },
            submitJourneyLog :{
            	url : '/dutySheetService/submit/journeyLog',
                type : 'GET',
                queryParam: ['blockId','version'],
                headerParam: headers.showLoading
            },
            searchTargetHours:{
            	url : '/rosterService/search/tragetHours',
           		type : 'POST',
           		headerParam: headers.showLoading
            },
            saveTargetHours :{
            	url : '/rosterService/save/tragetHours',
           		type : 'POST',
           		headerParam: headers.showLoading
            },
            getReportParam :{
              url : '/commonService/report/getReportParam',
              type : 'GET'
            },
            /*******************/
            /*COSMIC RADIATION ENDPOINTS*/
            searchCosmicRadiationValues: {
               url : '/radiation/search',
               type : 'POST',
               headerParam: headers.showLoading
            },
            addCosmicRadiationValue: {
                url : '/radiation/add',
                type : 'POST',
                headerParam: headers.showLoading
            },
            getCosmicRadiationConfig: {
                url : '/radiation/config',
                type : 'GET',
                headerParam: headers.showLoading
            },
            editCosmicRadiationValues: {
                url : '/radiation/edit',
                type : 'POST',
                headerParam: headers.showLoading
            },

            /*******************/
            /*MESSAGE ADMIN ENDPOINTS*/
            searchMessages: {
              url : '/messageService/search/message/admin',
              type : 'POST',
              headerParam: headers.showLoading
            },
            deleteMessage: {
              url : '/messageService/delete/message',
              type : 'POST',
              headerParam: headers.showLoading
            },
            saveMessage: {
                url : '/messageService/save/message',
                type : 'POST',
                headerParam: headers.showLoading
            },

            searchMessageInbox: {
                url : '/messageService/search/message/inbox',
                type : 'POST',
                headerParam: headers.showLoading
            },
            markAsRead: {
                url : '/messageService/message-inbox/mark/as/read',
                type : 'POST',
                headerParam: headers.showLoading
            },
            replyMessage: {
            	url : '/messageService/message/inbox/reply/msg',
                type : 'POST',
                headerParam: headers.showLoading
            },

            getPaxMessages: {
            	url :'/paxMessageService/getPaxMessages',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            getPaxMsgDetails:{
            	url :'/crewingService/getPaxMsgforCrew',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            paxMessageOverride:{
            	url :'/paxMessageService/paxMessage/override',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            getPaxMessageConfigs:{
            	url :'/paxMessageService/paxMessage/country/search',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            getPaxMessageTypes:{
            	url :'/paxMessageService/paxMessage/types',
            	type : 'GET',
                headerParam: headers.showLoading
            },
            getPaxMessageApisVersions:{
              url :'/paxMessageService/paxMessage/apisVersions',
              type : 'GET',
              headerParam: headers.showLoading
            },
            getPaxMessageFields:{
            	url :'/paxMessageService/paxMessage/fields',
            	type : 'GET',
                headerParam: headers.showLoading
            },
            getPaxMessageTriggers:{
            	url :'/paxMessageService/paxMessage/triggers',
            	type : 'GET',
                headerParam: headers.showLoading
            },
            savePaxMessageConfig:{
            	url :'/paxMessageService/paxMessage/config/save',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            getPaxMsgReSubmit:{
            	url :'/paxMessageService/paxMessage/reSubmit',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            sendPaxMsgManualy:{
            	url :'/paxMessageService/paxMessage/send/manualy',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            resubmitCancellation:{
            	url :'/paxMessageService/paxMessage/cancel/resubmit',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            searchLeaveTypeList: {
	            url: '/reportService/leaves',
	            type: 'GET'
            },
            searchAiportCategoriesList:{
	            url: '/adminService/search/airport/categories',
	            type: 'GET'
	        },
	        getMaxCrewBidding:{
		        url: '/crewingService/maxCrewBidding',
		        type: 'GET',
		        headerParam: headers.showLoading
	        },
	        editCrewMaxBidding:{
	        	url: '/crewingService/editCrewMaxBindding',
		        type: 'POST',
		        headerParam: headers.showLoading
	        },
	        getFlyingHourRates:{
	        	url: '/adminService/search/payment/hour/ranges',
	        	type: 'GET',
	        	headerParam: headers.showLoading,
	        	queryParam: ['crewType']
	        },
	        getOtherPaymentRates:{
	        	url: '/adminService/search/other/payment/rates',
	        	type: 'GET',
	        	queryParam: ['crewType']
	        },
	        saveFlyingHourRates:{
	        	url: '/adminService/save/payment/hour/range',
	        	type: 'POST'
	        },
	        deleteFlyingHourRates:{
	        	url: '/adminService/delete/payment/hour/range',
	        	type: 'POST'
	        },
	        saveOtherPaymentRates:{
	        	url: '/adminService/save/other/payment/rates',
	        	type: 'POST',
	        	headerParam: headers.showLoading
	        },
	        searchAcarsMessages :{
	        	url : '/messageService/search/acars/messages',
	        	type : 'POST',
	        	headerParam: headers.showLoading
	        },
	        getAcarsMessageStatus:{
	        	url : '/commonService/search/status/of/acars',
	        	type : 'GET',
	        },
	        searchVoyageReport : {
				url : '/crewService/search/voyage/report',
				type : 'POST',
				headerParam : headers.showLoading
			},
			loadDistributionList : {
				url : '/crewService/distribution/list',
				type : 'GET',
				headerParam : headers.showLoading
			},
			addSaveSendVoyageDetails : {
				url : '/crewService/edit/voyage/report',
				type : 'POST',
				headerParam : headers.showLoading
			},
          searchTrackingDiscrepancy: {
            url: '/crewService/search/training/discrepancy',
            type: 'POST',
            headerParam: headers.showLoading

          },

          loadRosterStatusReport: {
            url: '/crewService/search/crew/rosterStatusReport',
            type: 'POST',
            headerParam: headers.showLoading

          },

          searchCrewViolations: {
            url: '/crewService/search/crew/violations',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchCrewViolationsWithoutLoading: {
            url: '/crewService/search/crew/violations',
            type: 'POST'
          },

          searchDayAndEarlyMorningFlight: {
            url: '/crewService/search/crew/dayAndEarlyMorningFlight',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchMoreThanTwoDoubleSectorsInRollingSevenDays: {
            url: '/crewService/search/crew/moreThanTwoDoubleSectorsInRollingSevenDays',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchMorningFlightAfterNightFlight: {
            url: '/crewService/search/crew/morningFlightAfterNightFlight',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchMinRestBreachPriorToRktDeparture: {
            url: '/crewService/search/crew/minRestBreachPriorToRktDeparture',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchMultipleFlightsInRollingSevenDays: {
            url: '/crewService/search/crew/multipleFlightsInRollingSevenDays',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchDoubleSectorCount: {
            url: '/crewService/search/crew/doubleSectorCount',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchMorningFlightPriorToLayoverNight: {
            url: '/crewService/search/crew/morningFlightPriorToLayoverNight',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchDoubleSectorPriorToDayTurnaround: {
            url: '/crewService/search/crew/doubleSectorPriorToDayTurnaround',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchRosterStatusReportRadarChart: {
            url: '/rosterService/search/rosterRadarPlot',
            type: 'POST',
            headerParam: headers.showLoading
          },

          searchLanguageDiscrepancy: {
            url: '/crewService/search/language/discrepancy',
            type: 'POST',
            headerParam: headers.showLoading

          },

          searchMaleFemaleDiscrepancy: {
            url: '/crewService/search/male/female/discrepancy',
            type: 'POST',
            headerParam: headers.showLoading
          },

			closeVoyageEntry:{
            	url :'/crewService/close/voyage/report',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            searchCabinFlights:{
            	url :'/reportService/cabin/flight/reports/and/missing/reports',
            	type : 'POST',
                headerParam: headers.showLoading
            },
            loadEditPanelCabinFlightData:{
        		url :'/reportService/cabin/flight/form/data',
            	type : 'POST',
                headerParam: headers.showLoading
        	},
        	approveCabinFlight:{
        		url :'/reportService/add/feedback/and/approve/cabin/flight/report',
            	type : 'POST',
                headerParam: headers.showLoading
        	},
        	getCabinFlights:{
        		url:'/commonService/cabin/flight/types',
        		type : 'GET',
                headerParam: headers.showLoading
        	},
        	getTrainingAuditViewByTypes :{
        		url:'/commonService/training/audit/viewBy/types',
        		type : 'GET',
                headerParam: headers.showLoading
        	},
        	saveOrUpdateCabinFlight:{
        		url:'/reportService/edit/cabin/flight/report',
        		type : 'POST',
                headerParam: headers.showLoading
        	},
        	deleteCabinFlightEntry:{
        		url:'/reportService/remove/cabin/flight/report',
        		type : 'POST',
                headerParam: headers.showLoading
        	},

        	saveTrainingAutomationConfig:{
        		url:'/trainingService/add/training/config',
        		type : 'POST',
        		headerParam: headers.showLoading
        	},
        	searchTrainingAutomationConfig:{
        		url:'/trainingService/search/training/automation/configs',
        		type : 'GET',
        		headerParam: headers.showLoading,
        		queryParam: ['rosterCycleId']
        	},
        	deleteTrainingDistribution:{
        		url:'/trainingService/delete/training/schedule',
        		type : 'POST',
        		headerParam: headers.showLoading
        	},
        	deleteTrainingAutomationConfig:{
        		url:'/trainingService/delete/training/config',
        		type : 'POST',
        		headerParam: headers.showLoading
        	},
        	assignExternalTrainee: {
                 url: '/trainingService/assign/external/trainee',
                 type: 'POST',
                 headerParam: headers.showLoading
             },
             searchExternalTraineeSuggession: {
                 url: '/trainingService/search/external/trainee/suggestions',
                 type: 'GET',
                 headerParam: headers.showLoading
             },
          assignTrainings:{
            url:'/trainingService/run/training/schedule',
            type : 'POST',
            headerParam: headers.showLoading
          },
          getNumberOfInitialSearches: {
            url:'/commonService/appParams/trainingRoster/numberOfInitialSearches',
            type: 'GET'
          },
          getTrainingRosterExpiryStartDate: {
            url:'/commonService/appParams/trainingRoster/expiryStartDate',
            type: 'GET'
          },
          searchUsersByType: {
                 url: '/commonService/search/users/by/type',
                 type: 'GET',
                 headerParam: headers.showLoading,
                 queryParam: ['userType']

          },
          updateFlightInfo: {
        	  url: '/fleetService/update/flight/info',
              type: 'POST',
              headerParam: headers.showLoading
          },
          checkLogDetails: {
            url: '/fleetService/checkLogDetails',
            type: 'GET',
            headerParam: headers.showLoading,
            queryParam: ['aircraftCheckId']
          },
          searchCrewSignInScreenData: {
            url: '/reportService/crewSignInScreenData',
            type: 'GET',
            headerParam: headers.showLoading
          },
          searchFlightScreenData: {
            url: '/reportService/flightScreenData',
            type: 'GET',
            headerParam: headers.showLoading
          },
          getCabinPerformanceCommentReport:{
            url: '/reportService/get/cabin/performance/comment',
            type: 'POST',
            headerParam: headers.showLoading
          },
          updateCabinPerformanceComment:{
            url: '/reportService/update/cabin/performance/comment',
            type: 'POST',
            headerParam: headers.showLoading
          },
          checkFlightWatchSavePriviledge : {
            url: '/fleetService/check/flight/watch/save/priviledge',
            type: 'POST',
            headerParam: headers.showLoading
          },
          getAtcCallSignData :{
            url:'/atcCallSignService/search/atcCallSignData',
            type: 'POST',
            headerParam: headers.showLoading
          },
          saveAtcCallSign :{
            url:'/atcCallSignService/save/atcCallSign',
            type: 'POST',
            headerParam: headers.showLoading
          },
          deleteAtcCallSign :{
            url:'/atcCallSignService/delete/atcCallSign',
            type: 'POST',
            headerParam: headers.showLoading
          },
          saveConversionToMappingAtcCallSign :{
            url:'/atcCallSignService/save/conversion/mapping/call-sign',
            type: 'POST',
            headerParam: headers.showLoading
          },
          checkAircraftRegistrationUpdateStatus:{
            url: '/fleetService/amadeus/aircraftRegistration/updateStatusCheck',
            type: 'POST',
            headerParam: headers.showLoading
          },
          amadeusAircraftRegistrationSubmit:{
            url: '/fleetService/amadeus/aircraftRegistration/submit',
            type: 'POST',
            headerParam: headers.showLoading
          },
          getCrewTypesByIds: {
            url: '/commonService/crew/typesByIds',
            type: 'GET',
            queryParam: ['crewIds','fromDate','toDate']
          },
          getAuditTemplateGroups :{
            url:'/auditService/get/audit/template/group/list',
            type : 'GET',
            headerParam: headers.showLoading
          },
          getAuditTemplateList: {
            url: '/auditService/get/audit/template/list',
            type: 'GET',
            queryParam: ['auditGroup']
          },
          getAuditCreatedByList: {
            url: '/auditService/get/audit/createdBy/list',
            type: 'GET',
            headerParam: headers.showLoading
          },
          getSnapShotsByCycleId: {
            url: '/commonService/get/snapShotsBy/cycleId',
            type: 'GET',
            queryParam: ['cycleId']
          },
          getScoringVersionByCycleIdAndCrewType: {
            url: '/commonService/get/scoring',
            type: 'GET',
            queryParam: ['cycleId','crewType'],
            headerParam: headers.showLoading
	        },
          loadRosterSnaps: {
              url : '/rosterService/search/snaps',
              type : 'GET',
              queryParam: ['showAll']
          },
          saveRosterSnap :{
        	  url:'/rosterService/save/roster/sanp/shot',
              type: 'POST',
              headerParam: headers.showLoading
          },
          scoreSnap :{
        	  url:'/rosterService/score/snaps',
              type: 'POST',
              headerParam: headers.showLoading
          },
          restoreGridDuty: {
            url : '/rosterService/restore/grid/duty',
            type : 'POST'
          },
          getCmdDescretions : {
        	  url:'/cmd/descretion/service/search/descretion',
              type: 'POST',
              headerParam: headers.showLoading

          },
          getCmdDescretionsDetails : {
        	  url:'/cmd/descretion/service/search/descretion/details',
              type: 'POST',
              headerParam: headers.showLoading

          },
          getCommanderDiscReptCount : {
            url:'/cmd/descretion/service/get/report/count',
            type: 'POST',
            headerParam: headers.showLoading
          },
          saveAdminComanderDiscretion : {
              url:'/cmd/descretion/service/save/admin/remark',
              type: 'POST',
              headerParam: headers.showLoading
          },
          changeAdminComanderDiscretionStatus : {
              url:'/cmd/descretion/service/change/admin/status',
              type: 'POST',
              headerParam: headers.showLoading
          },getFlightOperationTypes : {
              url: '/commonService/flight/operation/types',
              type: 'GET',
              headerParam: headers.showLoading

          },
          getLeaveAssignmentRightClickOptions : {
            url: '/commonService/leave/types/for/right/click',
            type: 'GET',
            headerParam: headers.showLoading
          },
          getEventAssignmentRightClickOptions : {
            url: '/commonService/event/types/for/right/click',
            type: 'GET',
            headerParam: headers.showLoading
          },
          searchCarriers : {
        	  url: '/pairingService/search/carriers',
              type: 'GET',
              headerParam: headers.showLoading
          },
          searchCarriersList : {
            url: '/pairingService/search/carriersList',
            type: 'GET',
            headerParam: headers.showLoading
          },
          getSalesTarget: {
            url: '/crewingService/get/salesTarget',
            type: 'POST',
            headerParam: headers.showLoading
          },
           searchMapPairingGroups : {
            url: '/pairingService/search/pairingDistributionGroups',
            type: 'POST',
            headerParam: headers.showLoading
          },

          updateIdentifiers : {
            url: '/pairingService/update/pairingDistributionGroups',
            type: 'POST',
            headerParam: headers.showLoading
          },
          getProgramCodeList: {
            url: '/commonService/training/programCodes',
            type: 'GET'
          },getTrainingLocationList: {
            url: '/commonService/training/locations',
            type: 'GET'
          },getTraineeList: {
            url: '/commonService/training/trainees',
            type: 'GET'
          },getTrainerList: {
            url: '/commonService/training/trainers',
            type: 'GET'
          },getCabinFlightReportRemarkList:{
            url: '/reportService/getCabinFlightReportRemarkList',
            type: 'GET',
            queryParam: ['reportId'],
            headerParam: headers.showLoading
          },updateCabinFlightReportFeedback:{
            url: '/reportService/updateCabinFlightFeedback',
            type: 'POST',
            headerParam: headers.showLoading
          },sendCabinFlightReportFeedback:{
            url: '/reportService/sendCabinFlightFeedback',
            type: 'POST',
            headerParam: headers.showLoading
          },uploadRemarkImage:{
            url: '/reportService/cabin/remark/upload/image',
            type: 'POST'
          },getRemarkImageUrl:{
            url: '/reportService/cabin/remark/image/url',
            type: 'GET',
            queryParam: ['objectName']
          },getTrainingDescription: {
              url:'/commonService/training/programDesc',
              type:'GET'
          },
          getFlyingHours: {
            url:'/crewingService/search/flying/hours',
            type:'POST'
          },
          notifyCrewScheduleChange : {
            url: '/crewingService/notify/crewScheduleChange',
            type: 'POST'
          },
          replacePatternWithOverlapped: {
            url: '/crewingService/replace/overlapped/pattern',
            type: 'POST',
            headerParam: headers.showLoading
          },
          getDropDownList: {
              url: '/commonService/dropdown/list',
              type: 'GET',
              queryParam: ['dropdownId']
          },getDelayedReportTiming : {
            url: '/crewingService/delayedReporting',
            type: 'POST'
          },
          updateDelayedReportTiming : {
            url: '/crewingService/updateDelayReporting',
            type: 'POST',
            headerParam: headers.showLoading
          },
          openVoyageEntry:{
            url :'/crewService/open/voyage/report',
            type : 'POST',
            headerParam: headers.showLoading
          },
          loadVoyageRedirectingDepartmentsList : {
            url : '/crewService/voyage/redirecting/list',
            type : 'GET',
            headerParam : headers.showLoading
          },
          ignoreRegulationViolations: {
            url: '/crewingService/update/crew/schedule/block/ignore-violations',
            type: 'POST'
          },
          restoreRegulationViolations: {
            url: '/crewingService/update/crew/schedule/block/restore-violations',
            type: 'POST'
          },
          getCrewACMIData: {
            url: '/crewService/search/crewACMIData',
            type: 'POST'
          },
          getCrewACMIHistory: {
            url: '/crewService/search/crewACMIRangeHistory',
            type: 'POST'
          },
          addCrewACMIRange: {
            url: '/crewService/add/crewACMIRange',
            type: 'POST',
            headerParam: headers.showLoading
          },
          editCrewACMIRanges: {
            url: '/crewService/batch/edit/crewACMIRange',
            type: 'POST',
            headerParam: headers.showLoading
          },
          deleteCrewACMIRange: {
            url: '/crewService/delete/crewACMIRange',
            type: 'POST',
            headerParam: headers.showLoading
          },
          getCarrierCode: {
            url: '/commonService/duty/sheet/carrier/code',
            type: 'GET'
          },
          getCrewAirportRecencyData:{
            url: '/crewService/crewAirportRecency',
            type: 'GET',
            pathParam: ['crewProfileId'],
            headerParam: headers.showLoading
          },
          getCrewLayoverAccommodationPreferences:{
            url: '/crewService/crewLayoverAccommodationPreferences',
            type: 'GET',
            pathParam: ['crewProfileId'],
            headerParam: headers.showLoading
          },
          checkAirportRecency: {
            url: '/crewingService/check/airport/recency',
            type: 'POST'
          },
          getDefaultPasswords:{
            url: '/adminService/default/passwords',
            type: 'GET'
          },
        };

        var formSubmitEndPoints = {
            documentManageUpload: '/adminService/save/documentList',
            messageManageUpload: '/messageService/save/message',
            headerParam: headers.showLoading
        };

        var documentDownload = {
                endPoint: '/adminService/download/document'
        };

        self.downloadDocumentFromServer = function (data, successFn, errorFn) {
            var url = baseUrl + documentDownload.endPoint;

            var req = {  method: 'POST', url: url,   responseType : 'arraybuffer', data: data }

			$http(req).success(function(response) {
				successFn(response);
			}).error(function(error) {
				errorFn(error);
			});
        };

        self.submitAsFormRequest = function ( urlSpec ,formData, successFn, errorFn) {
            var url = baseUrl + formSubmitEndPoints[urlSpec];
            $http.post(url, formData, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                })
                .success(function (response) {
                    successFn(response);
                })

                .error(function (error) {
                    errorFn(error);
                });
        };


        var getRequestOption = function (method, headerParam) {
            var req = {};
            if (method === 'POST') {
                req.method = 'POST';
                req.headers = {
                    'Content-Type': 'application/json'
                };
            } else {
                req.method = 'GET';
                req.headers = {
                    'Content-Type': 'text/plain'
                };
            }

            if (!!headerParam) {
                angular.forEach(Object.keys(headerParam), function (paramName) {
                    req.headers[paramName] = headerParam[paramName];
                });
            }
            return req;
        };

        var getErrorObj = function (data) {
            var obj = {
                msg: data ? data.errors : []

            };
            return obj;
        };

        var getRequest = function (endPointName, requestParams) {
            var tmpConfig = endPointConfig[endPointName];

            var getUrl = function () {
                var url = tmpConfig.url;
                if (tmpConfig.type == "GET") {
                    //Set Query Params
                    if (!!tmpConfig.queryParam && tmpConfig.queryParam.length > 0) {
                        angular.forEach(tmpConfig.queryParam, function (param, index) {
                            if (index == 0) {
                                url = url + '?' + param + '=' + requestParams[param];
                            } else {
                                url = url + '&' + param + '=' + requestParams[param]
                            }
                        })
                    } else if (!!tmpConfig.pathParam && tmpConfig.pathParam.length > 0) {
                        angular.forEach(tmpConfig.pathParam, function (param) {
                            url = url + '/' + requestParams[param]
                        })

                    }
                }
                return url;
            };

            var request = angular.extend({}, getRequestOption(tmpConfig.type, tmpConfig.headerParam), {
                url: baseUrl + getUrl(),
                data: requestParams
            });
            return request;
        };

        var getParams = function (argumentValues, argumentNames) {
            var param = {};
            angular.forEach(argumentNames, function (arg, index) {
                param[arg] = argumentValues[index];
            });
            return param;
        };


        var getPromise = function (request) {
            var deferred = $q.defer();
            $http(request)
                .success(function (data) {
                    deferred.resolve(data);
                })
                .error(function (data) {
                    deferred.reject(getErrorObj(data));
                });
            return deferred.promise;
        };

        (function init() {
            angular.forEach(Object.keys(endPointConfig), function (endPointName) {
                var tmpConfig = endPointConfig[endPointName];
                var requestParams;
                self[endPointName] = function () {
                    var argValuesCol = arguments;
                    if (tmpConfig.type == 'GET') {
                        if (tmpConfig.queryParam && tmpConfig.queryParam.length > 0) {
                            requestParams = getParams(argValuesCol, tmpConfig.queryParam);
                        } else if (tmpConfig.pathParam && tmpConfig.pathParam.length > 0) {
                            requestParams = getParams(argValuesCol, tmpConfig.pathParam);
                        }
                    } else {
                        requestParams = argValuesCol[0];
                    }
                    var req = getRequest(endPointName, requestParams);

                    //Set headers
                    if (angular.isDefined(this.headerParam)) {
                        var scope = this;
                        angular.forEach(Object.keys(this.headerParam), function (key) {
                            req.headers[key] = scope.headerParam[key];
                        });
                    }

                    if(angular.isDefined(tmpConfig.responseType)) {
                      req.responseType = tmpConfig.responseType
                    }

                    return getPromise(req);
                };
            });

        })();
    };
}());
